import React from 'react';
import { Link } from 'react-router-dom';

const GruposLotados = () => {
    return (
        <div className="container" style={{ padding: '80px 20px', textAlign: 'center', minHeight: '60vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
            <div style={{
                width: '100px',
                height: '100px',
                backgroundColor: '#f8d7da',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginBottom: '20px'
            }}>
                <i className="fas fa-users-slash" style={{ fontSize: '48px', color: '#dc3545' }}></i>
            </div>

            <h1 style={{ color: '#2d3277', marginBottom: '15px' }}>Grupos Temporariamente Lotados</h1>

            <p style={{ fontSize: '1.1rem', color: '#666', maxWidth: '600px', margin: '0 auto 30px auto', lineHeight: '1.6' }}>
                Pedimos desculpas! Devido à alta demanda, todos os nossos grupos de ofertas no WhatsApp atingiram a capacidade máxima no momento.
            </p>

            <div style={{ backgroundColor: '#fff3cd', border: '1px solid #ffeeba', borderRadius: '8px', padding: '15px', maxWidth: '500px', marginBottom: '30px' }}>
                <p style={{ margin: 0, color: '#856404' }}>
                    <i className="fas fa-clock"></i> Estamos criando novos grupos. Por favor, tente novamente em alguns minutos.
                </p>
            </div>

            <div style={{ display: 'flex', gap: '15px', flexWrap: 'wrap', justifyContent: 'center' }}>
                <Link to="/" className="btn-primary" style={{ textDecoration: 'none', padding: '12px 24px', borderRadius: '30px' }}>
                    <i className="fas fa-arrow-left"></i> Voltar para Ofertas
                </Link>

                <a href="https://instagram.com/ofertiz" target="_blank" rel="noopener noreferrer" className="btn-secondary" style={{ textDecoration: 'none', padding: '12px 24px', borderRadius: '30px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <i className="fab fa-instagram"></i> Siga no Instagram
                </a>
            </div>
        </div>
    );
};

export default GruposLotados;
